module.exports = __webpack_public_path__ + "static/media/wood_satin.a423967f.png";